import { Link } from 'react-router-dom';
import { CheckCircle, Phone, Calendar, ChevronDown } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useState } from 'react';
import SEO from '../../components/SEO';

const GAINSWave = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const benefits = [
    'Achieve harder & stronger erections',
    'Improve sexual performance',
    'Increase sensation',
    'Treat ED & Peyronie\'s disease symptoms',
    'Non-invasive, drug-free treatment',
    'No downtime or recovery period',
  ];

  const howItWorks = [
    'Uses low-intensity acoustic wave therapy',
    'Stimulates new blood vessel growth (angiogenesis)',
    'Breaks down micro-plaque in blood vessels',
    'Activates dormant stem cells for tissue regeneration',
    'Restores natural, spontaneous erectile function',
  ];

  const candidates = [
    'Men experiencing erectile dysfunction',
    'Men with Peyronie\'s disease',
    'Men seeking enhanced sexual performance',
    'Men looking for a drug-free alternative to ED medications',
    'Men who want to maintain long-term sexual health',
  ];

  const faqs = [
    { q: 'What is GAINSWave therapy?', a: 'GAINSWave is a scientifically proven, non-invasive treatment that uses low-intensity shockwave therapy to improve blood flow, restore erectile function, and enhance sexual performance. It addresses the root cause of ED rather than just masking symptoms.' },
    { q: 'How many treatments are needed?', a: 'A typical treatment protocol involves a series of sessions, usually 6-12 treatments over several weeks. Dr. Havkin will create a personalized plan based on your specific needs and goals.' },
    { q: 'Is the treatment painful?', a: 'Most patients describe the treatment as comfortable with little to no discomfort. The procedure is performed in-office and requires no anesthesia or sedation.' },
    { q: 'How soon will I see results?', a: 'Some men notice improvements after just a few sessions, while optimal results typically develop over the full course of treatment. Results can last 2-3 years or longer.' },
    { q: 'Are there any side effects?', a: 'GAINSWave therapy has minimal to no side effects. There is no downtime, and patients can resume normal activities immediately after treatment.' },
    { q: 'Is GAINSWave covered by insurance?', a: 'GAINSWave is typically not covered by insurance as it is considered an elective treatment. Our office can discuss payment options during your consultation.' },
  ];

  return (
    <div className="pb-20 md:pb-0">
      <SEO
        title="GAINSWave Shockwave Therapy Melbourne FL"
        description="GAINSWave shockwave therapy for ED and Peyronie's disease at Havkin Urology in Melbourne, FL. Non-invasive, drug-free treatment for enhanced sexual performance. Call (321) 500-4545."
        keywords="GAINSWave Melbourne FL, shockwave therapy ED, GAINSWave treatment, erectile dysfunction shockwave, Peyronie's disease treatment, sexual enhancement"
        canonical="/services/gainswave"
      />

      {/* Breadcrumb */}
      <div className="bg-slate-50 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center text-sm text-slate-500">
            <Link to="/" className="hover:text-black">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/mens-health" className="hover:text-black">Services</Link>
            <span className="mx-2">/</span>
            <span className="text-primary">GAINSWave Therapy</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-black font-medium mb-2">A Breakthrough Solution for Men</p>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6">GAINSWave Therapy</h1>
              <p className="text-lg text-slate-600 leading-relaxed mb-6">
                GAINSWave is a breakthrough solution for men with Erectile Dysfunction, Peyronie's Disease, or any man seeking scientifically proven male enhancement. This non-invasive, drug-free treatment uses low-intensity shockwave therapy to restore natural erectile function and enhance sexual performance.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  asChild
                  size="lg"
                  className="bg-brand hover:bg-brand-hover text-white rounded-full px-8"
                  data-testid="gainswave-cta-appointment"
                >
                  <Link to="/contact">
                    <Calendar className="h-5 w-5 mr-2" />
                    Request Consultation
                  </Link>
                </Button>
                <a
                  href="tel:+13215004545"
                  className="inline-flex items-center justify-center px-8 py-3 bg-white border border-slate-200 text-primary rounded-full font-medium hover:bg-slate-50 transition-colors"
                  data-testid="gainswave-cta-call"
                >
                  <Phone className="h-5 w-5 mr-2" />
                  (321) 500-4545
                </a>
              </div>
            </div>
            <div className="flex flex-col gap-6">
              <img
                src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/xrqluhif_Havkin_GAINSWave.png"
                alt="GAINSWave Logo"
                className="w-full max-w-md mx-auto rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Breakthrough Image */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-xl overflow-hidden shadow-lg border border-slate-100">
            <img
              src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/c92j8p37_Havkin_Breakthrough.png"
              alt="GAINSWave - A Breakthrough Solution for Men with Erectile Dysfunction, Peyronie's Disease - Havkin Urology"
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Benefits & How It Works */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="font-heading text-2xl font-bold text-primary mb-6">Benefits of GAINSWave</h2>
              <ul className="space-y-3">
                {benefits.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-black flex-shrink-0 mr-3 mt-0.5" />
                    <span className="text-slate-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="font-heading text-2xl font-bold text-primary mb-6">How GAINSWave Works</h2>
              <ul className="space-y-3">
                {howItWorks.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-black flex-shrink-0 mr-3 mt-0.5" />
                    <span className="text-slate-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Who Is a Candidate */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-bold text-primary mb-8">Who Is a Candidate?</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {candidates.map((item, idx) => (
              <div key={idx} className="bg-slate-50 p-6 rounded-xl border border-slate-100">
                <div className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-black flex-shrink-0 mr-3 mt-0.5" />
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-bold text-primary mb-8">FAQs</h2>
          <div className="space-y-4">
            {faqs.map((f, idx) => (
              <div key={idx} className="bg-white rounded-xl border border-slate-100">
                <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left">
                  <span className="font-semibold text-primary pr-4">{f.q}</span>
                  <ChevronDown className={`h-5 w-5 text-slate-400 flex-shrink-0 transition-transform ${openFaq === idx ? 'rotate-180' : ''}`} />
                </button>
                {openFaq === idx && <div className="px-5 pb-5 text-slate-600">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-16 bg-black text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-bold text-white mb-4">Ready to Get Started with GAINSWave?</h2>
          <p className="text-gray-300 mb-8">Schedule a confidential consultation to learn how GAINSWave therapy can help you.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-white text-black hover:bg-gray-200 rounded-full px-8">
              <Link to="/contact">Request Appointment</Link>
            </Button>
            <a href="tel:+13215004545" className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-white rounded-full font-medium hover:bg-white/10">
              <Phone className="h-5 w-5 mr-2" />(321) 500-4545
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GAINSWave;
